import { render, staticRenderFns } from "./ChangeAccountComponent.vue?vue&type=template&id=13a3d2d9&"
import script from "./ChangeAccountComponent.vue?vue&type=script&lang=js&"
export * from "./ChangeAccountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports